<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="10">
          <el-form-item label="Frequency Graph">
            <div class="uploader-file">
              <el-upload
                action="" :http-request="uploadFile" :show-file-list="false"
                :data="{ model: 'products', id: product._id, type: 'frequency' }"
              >
                <el-button type="text">Upload</el-button>
              </el-upload>
              <div class="uploader-file-name">
                <span>{{ frequency.name }}</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateProduct" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'TabFrequency',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      product: {},
      frequency: {},
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) {
            this.product = { ...val }
          }
          if (val.frequency_graph) this.frequency = { ...val.frequency_graph }
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Frequency Graph') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    updateProduct: function () {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'frequency_graph', content: this.frequency }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProduct', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    uploadFile: async function (params) {
      const { file, data } = params
      this.frequency.name = 'uploading...'
      const that = this
      const formData = new FormData()
      formData.append('file', file)
      for (const key in data) {
        formData.append(key, data[key])
      }
      this.$service.request({
        url: '/api/v1/atk_player/upload/files',
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        that.triggerTabUpdate()
        if (res.code === 200) {
          that.frequency = { url: res.record.audio.url, name: file.name }
        }
      }).catch((err) => {
        console.error('uploadFile', err)
      }).then(() => {
      })
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Frequency Graph')
    }
  }
}
</script>
